export const Constants = {
  env:"PROD",
  version:"2.3",
  CoachScreenLimit: 3,
  uatCoachScreenToken: "",
  prodCoachScreenToken: "",
  agentLogToken:"",
  TSAgentServerUrlUAT: "https://dchatsrv.tataplay.com/genesys/cometd",
  TSAgentServerUrl: "https://chat.tataplay.com/genesys/cometd",
  TSAgentChatChannel: "/service/chatV2/customer-support",
  data: {
    operation: "requestChat",
    nickname: "",
    firstName: "",
    lastName: "",
    subject:
      "",
    userData: {
      insertedID: "FAILURE ",
      _provide_code: "false",
      cti_flowname: "GBM",
      cti_src: "GBM",
      cti_first_name: "",
      FirstName: "",
      cti_last_name: "",
      LastName: "",
      cti_email_address: "",
      EmailAddress: "",
      cti_cust_cat: "MASS",
      cti_SubscriberID: "",
      cti_city: "",
      cti_userFirstMessage: "1",
      PhoneNumber: "",
      IdentifyCreateContact: "3",
      MediaType: "chat",
    },
  },

  litmusUrl:
    "https://app.litmusworld.com/cs/api/api/feedbackrequests/tatasky_initiate_feedback",
  testLitmusData: {
    app_id: "yimd_chat",
    customer_id: "",
    tag_user_type: "Regular",
    tag_city: "",
    tag_subscriberId: "",
    tag_source: "CHAT",
    tag_transType: "Subscriber",
    tag_interactionID: "",
    user_email: "",
    user_phone: "",
    tag_agent_name: "",
    tag_full_name: "",
    tag_transcript: "",
    tag_agentID: "IGSM514853",
  },
  chatHeight: document?.getElementById("top")?.clientHeight,
  chatWidth: document?.getElementById("top")?.clientWidth,
  dormancyMessage:"Seems you are away and we lost the connection.You are a valued TATA Play subscriber and you can reinitiate the chat anytime by typing below. We will be happy to assist you"
};
